<template>
  <div class="onboarding">
    <OnboardingHeader />
    <div class="mw-600 px-5 ml-auto mr-auto">
      <v-stepper v-model="onboardingStepsNavigation" class="elevation-0">
        <v-stepper-items class="py-5">
          <v-stepper-content class="px-0" step="1">
            <OnboardingStepsCity />
          </v-stepper-content>

          <v-stepper-content class="px-0" step="2">
            <OnboardingStepsServices />
          </v-stepper-content>

          <v-stepper-content class="px-0" step="3">
            <OnboardingStepsPlans />
          </v-stepper-content>

          <v-stepper-content class="px-0" step="4">
            <OnboardingStepsFootage />
          </v-stepper-content>

          <!-- <v-stepper-content class="px-0" step="5">
            <OnboardingStepsContract />
          </v-stepper-content> -->

          <v-stepper-content class="px-0" step="5">
            <OnboardingStepsPayment />
          </v-stepper-content>

          <v-stepper-content class="px-0" step="7">
            <OnboardingStepsCityNotAvailable />
          </v-stepper-content>

          <v-stepper-content class="px-0" step="8">
            <OnboardingStepsNoRecurringPayment />
          </v-stepper-content>

          <v-stepper-content class="px-0" step="9">
            <OnboardingStepsSuccess />
          </v-stepper-content>
        </v-stepper-items>
        <v-stepper-header
          class="onboarding__steps mw-150 mx-auto elevation-0"
          :class="{ 'is-hidden': checkHidden }"
        >
          <v-stepper-step step="1" />
          <v-divider />
          <v-stepper-step step="2" />
          <v-divider />
          <v-stepper-step step="3" />
          <v-divider />
          <v-stepper-step step="4" />
          <v-divider />
          <v-stepper-step step="5" />
          <v-divider />
          <v-stepper-step step="6" />
        </v-stepper-header>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import OnboardingHeader from '@/components/onboarding/OnboardingHeader'
import OnboardingStepsNavigation from '@/components/onboarding/OnboardingStepsNavigation'

import OnboardingStepsCity from '@/components/onboarding/steps/OnboardingStepsCity'
import OnboardingStepsServices from '@/components/onboarding/steps/OnboardingStepsServices'
import OnboardingStepsPlans from '@/components/onboarding/steps/OnboardingStepsPlans'
import OnboardingStepsFootage from '@/components/onboarding/steps/OnboardingStepsFootage'
import OnboardingStepsPayment from '@/components/onboarding/steps/OnboardingStepsPayment'

import OnboardingStepsContract from '@/components/onboarding/steps/OnboardingStepsContract'

import OnboardingStepsCityNotAvailable from '@/components/onboarding/steps/OnboardingStepsCityNotAvailable'
import OnboardingStepsNoRecurringPayment from '@/components/onboarding/steps/OnboardingStepsNoRecurringPayment'
import OnboardingStepsSuccess from '@/components/onboarding/steps/OnboardingStepsSuccess'

import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'OnboardingSteps',

  components: {
    OnboardingHeader,
    OnboardingStepsNavigation,
    OnboardingStepsCity,
    OnboardingStepsServices,
    OnboardingStepsPlans,
    OnboardingStepsFootage,
    OnboardingStepsPayment,

    OnboardingStepsContract,

    OnboardingStepsCityNotAvailable,
    OnboardingStepsNoRecurringPayment,
    OnboardingStepsSuccess,
  },

  computed: {
    ...mapGetters(['onboardingStepsNavigation']),

    checkHidden() {
      const hiddenNumbers = [7, 8, 9]
      return hiddenNumbers.includes(this.onboardingStepsNavigation)
    },
  },

  methods: {
    ...mapMutations(['setOnboardingStepsNavigation']),

    validateAccess() {
      const usersOnboardStatus = localStorage.getItem('users_onboard_status')
      
      switch (usersOnboardStatus) {
        case 'NO_CITY', 'NO_CREDIT':
          this.$router.push('/onboarding/steps') 
          this.setOnboardingStepsNavigation(1)
          break;
        case 'NO_SUBSCRIPTION':
          this.$router.push('/onboarding/steps') 
          this.setOnboardingStepsNavigation(8)
          break;
        case 'CITY_NOT_AVAILABLE':
          this.$router.push('/onboarding/steps')
          this.setOnboardingStepsNavigation(7)
          break;
        default:
          this.$router.push('/') 
          break;
      }
    },
  },

  mounted() {
    this.validateAccess()
  },
}
</script>

<style lang="scss" scoped>
.is-hidden {
  opacity: 0;
}
</style>
